import Navbar from "../navbar/navbar";
import MobileNavBar from "../mobileNavBar/mobileNavBar";
import "./template.css";
import Footer from "../footer/footer";
const Template = (props) => {
  return (
    <>
      <header>
        <Navbar />
        <div className="mobile-navbar-container">
          <MobileNavBar></MobileNavBar>
        </div>
      </header>

      <main>{props.children}</main>

      <Footer></Footer>
    </>
  );
};

export default Template;
